import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { EASE, GoldButton, OutlineButton } from "@/components/Reveal";

export default function PaymentCancelPage() {
  return (
    <section className="flex min-h-[100svh] items-center justify-center bg-navy-800 px-5 pt-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="max-w-xl text-center"
        data-testid="payment-cancel-panel"
      >
        <h1 className="font-serif text-5xl font-medium text-ivory sm:text-6xl">
          Payment <em className="italic text-gold">cancelled</em>
        </h1>
        <p className="mt-6 text-sm font-light leading-relaxed text-mist sm:text-base">
          No worries — your booking wasn't completed and nothing has been charged. If you'd rather
          book over the phone, we're on +353 86 251 8252, any day from 9am to 6pm.
        </p>
        <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
          <GoldButton href="/experiences" testId="payment-cancel-tours">Back to Tours</GoldButton>
          <OutlineButton href="tel:+353862518252" testId="payment-cancel-call">
            <Phone className="mr-2 h-3.5 w-3.5" /> +353 86 251 8252
          </OutlineButton>
        </div>
        <p className="mt-8 text-[12px] text-mist/70">
          Questions first? <Link to="/contact" className="text-gold hover:underline">Send an enquiry</Link> and
          we'll build your perfect day.
        </p>
      </motion.div>
    </section>
  );
}
